<template>
	<span class="sorting-icon">
		<span v-show="sorting !== 'desc'" class="asc"></span>
		<span v-show="sorting !== 'asc'" class="desc"></span>
	</span>
</template>

<script lang="ts" setup>
	import type {PropType} from 'vue';

	defineProps({
		sorting: {
			type: String as PropType<'asc' | 'desc' | null>,
			default: null
		}
	});
</script>

<style scoped>
	.sorting-icon {
		--arrow-size: 3px;
		vertical-align: middle;
		display: inline-grid;
		grid-template-rows: var(--arrow-size) var(--arrow-size);
		gap: calc(var(--arrow-size) * .66667);
		justify-items: center;
	}

	.asc, .desc {
		display: block;
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 0 var(--arrow-size) var(--arrow-size) var(--arrow-size);
		border-color: transparent transparent #000000 transparent;
		transform: rotate(0deg);
	}

	.desc {
		transform: rotate(180deg);
		grid-row: 2;
	}
</style>
